<router-outlet></router-outlet>
<app-menu *ngIf="!isWelcomeEmailRoute && !isContactConfirmationRoute && !isJobOfferRoute"></app-menu> 
<app-spinner *ngIf="!isWelcomeEmailRoute && !isContactConfirmationRoute && !isJobOfferRoute"></app-spinner>
<router-outlet></router-outlet>
<app-footer *ngIf="!isWelcomeEmailRoute && !isContactConfirmationRoute && !isJobOfferRoute"></app-footer>

